/**
 * The names a plan-limit refusal carries, apart from the catalogue (`billing-plans.ts`), which
 * re-exports them (gate 697, T-0559). The web app says a refusal's sentence from these on every
 * launch (I-1712, `planLimitRefusal.ts`), and a launch has no use for the catalogue's plans and
 * prices: reading the code from the catalogue put all of it in the launch entry.
 */

/** The structured code a plan-limit refusal carries, beside ADR-095's `ENTITLEMENT_REQUIRED`. */
export const PLAN_LIMIT_REACHED_CODE = 'PLAN_LIMIT_REACHED';

/** Which limit a state or a refusal is about. A closed set so a client can say the right sentence. */
export const PLAN_LIMITS = [
  'active_agents_per_month',
  'work_areas',
  'active_reporters_per_month',
  'core_seats',
] as const;
export type PlanLimitType = (typeof PLAN_LIMITS)[number];
